export default __webpack_public_path__ + "static/media/404.f9264989.jpg";